import { colors, media, radius, shadows, spacing } from '@lamimed/pantheon';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: ${spacing.large};
  background-color: ${colors.neutral_extra_light};
`;

export const Card = styled.div`
  background-color: ${colors.light};
  border-radius: ${radius.medium};
  box-shadow: ${shadows.default};
  padding: ${spacing.xlarge};
  width: 100%;
  max-width: 50rem;
  text-align: center;

  ${media.greaterThan('tablet')`
    padding: ${spacing.xxlarge};
  `}
`;

export const Title = styled.h1`
  font-size: 2.8rem;
  font-weight: 700;
  color: ${colors.dark};
  margin-bottom: ${spacing.medium};
`;

export const Body = styled.p`
  font-size: 1.6rem;
  color: ${colors.dark};
  line-height: 1.5;
  margin-bottom: ${spacing.large};
`;

export const CTALink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing.small} ${spacing.large};
  background-color: ${colors.primary};
  color: ${colors.light};
  border: none;
  border-radius: ${radius.medium};
  font-size: 1.6rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }
`;
